/**
 * iter317 — Phase 7B: Plan-gating UI infrastructure.
 *
 * Global, headless event bus that lets ANY part of the app (axios
 * interceptor, page handlers, components) request the upgrade modal
 * be shown for a missing plan feature. The actual UI lives in
 * <UpgradeModal/>, mounted once at the app shell level.
 *
 * Usage:
 *   import { promptUpgrade } from '@/lib/upgradePrompt';
 *   promptUpgrade('tournaments.registrations', 'Run a tournament');
 *
 * Or, more typically, the axios 402 interceptor calls this with the
 * `X-Feature-Required` header value from the server's response.
 */
const listeners = new Set();

export function subscribeUpgradePrompt(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export function promptUpgrade(featureKey, actionLabel) {
  // No-op if nobody's listening (e.g. login page renders before the
  // modal mounts). Better silent than crashy.
  for (const cb of listeners) {
    try { cb({ featureKey, actionLabel }); } catch (_e) { /* ignore */ }
  }
}
